/**
 * Pass 1 of the streaming question parse emits one placeholder per detected
 * question ("Loading question 3...") and Pass 2 replaces each with the real
 * text. A placeholder is NOT a question: it must never be counted towards a
 * launchable survey, previewed as real, persisted, or run against Twins — a
 * study once shipped "Loading question 1..." to 71 twins that way (#514).
 */

export const placeholderQuestionText = (index: number): string => `Loading question ${index + 1}...`;

const PLACEHOLDER_TEXT_PATTERN = /^\s*loading question \d+\.\.\.\s*$/i;

type PlaceholderCandidate = string | { isLoading?: boolean; text?: string } | null | undefined;

/**
 * `isLoading` is the structural flag and the primary signal; the text pattern
 * is the fallback for payloads persisted before the flag was gated on, where
 * only the placeholder text identifies them.
 */
export const isPlaceholderQuestion = (question: PlaceholderCandidate): boolean => {
  if (!question) return false;
  if (typeof question === 'string') return PLACEHOLDER_TEXT_PATTERN.test(question);
  return question.isLoading === true || PLACEHOLDER_TEXT_PATTERN.test(question.text ?? '');
};

export const hasPlaceholderQuestion = (questions: unknown): boolean =>
  Array.isArray(questions) && questions.some(isPlaceholderQuestion);
